import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://tppsulxfgydeikcpyugt.supabase.co";
const supabaseKey = "sb_publishable_O1uwJxE_ebKkbKaXKkd0Xg_mES1Bx1M";

export const supabase = createClient(supabaseUrl, supabaseKey);